import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import UserDescriptionsBox from "./user-descriptions-box";
import UserImage from "./user-image";
import UserStatus from "./user-status";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import Album from "../../../../../core/et3-pop-up-album";
import ET3Div from "../../../../../core/et3-div";

const UserDetailsBox = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const isVisible = getUserAdvancedStore().userIDs.get().length > 0;

  return isVisible ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1500}
      height={305}
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1500}
        height={305}
        fDirection="row"
        alignItems="flex-start"
        justifyContent="space-around"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <UserImage />
        <Album />
        <UserStatus />
        <UserDescriptionsBox />
      </ET3Div>
    </ET3Div>
  ) : null;
});
export default UserDetailsBox;
